import styled from 'styled-components';
import { Flex, FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

const Wrapper = styled(FlexColumn)`
  justify-content: center;
  background: ${({ theme }) => theme.palette.common.white};
  padding: 16px;
  border-radius: 8px;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.gray13};
`;

const LegendChip = styled(Flex)`
  align-items: center;
  gap: 8px;
`;

const ChipIcon = styled.div<{ type: string }>`
  height: 10px;
  width: 10px;
  border-radius: 100%;
  border: 1px solid
    ${({ theme, type }) =>
      type === 'source'
        ? theme.palette.common.blue2
        : type === 'exposure'
        ? theme.palette.common.purple
        : type === 'filtered'
        ? theme.palette.common.pink
        : type === 'semantic'
        ? theme.palette.common.green
        : ''};
  background: ${({ theme, type }) =>
    type === 'source'
      ? theme.palette.common.lightBlue4
      : type === 'exposure'
      ? theme.palette.common.lightPurple
      : type === 'filtered'
      ? theme.palette.common.lightPink
      : type === 'semantic'
      ? theme.palette.common.lightTurqoise
      : ''};
`;

type Props = {
  className?: string;
  /** Label for the highlighted/selected nodes legend entry. Defaults to "Filtered". */
  selectedLabel?: string;
};

const Legend = ({ className, selectedLabel = 'Filtered' }: Props) => (
  <Wrapper className={className}>
    <LegendChip>
      <ChipIcon type="source" />
      <Typography>Source</Typography>
    </LegendChip>
    <LegendChip>
      <ChipIcon type="exposure" />
      <Typography>Exposure</Typography>
    </LegendChip>
    <LegendChip>
      <ChipIcon type="filtered" />
      <Typography>{selectedLabel}</Typography>
    </LegendChip>
    <LegendChip>
      <ChipIcon type="semantic" />
      <Typography>Semantic</Typography>
    </LegendChip>
  </Wrapper>
);

export default Legend;
